/**
 * Барьер от падений рендера: вместо пустой страницы — названная ошибка.
 *
 * Зачем. Когда backend-api убрал поле user из ответа входа, интерфейс падал
 * на JSON.parse('undefined') ещё в инициализаторе useState. React, не найдя
 * барьера, снимал всё дерево — пользователь видел ЧЁРНЫЙ ЭКРАН без единого
 * слова, а в консоль смотреть не обязан. Поломка такого рода неотличима от
 * «сайт лежит», и сообщить о ней можно только скриншотом пустоты: ни причины,
 * ни способа себе помочь.
 *
 * Барьер не чинит ошибку и не прячет её — он называет её и даёт выход.
 * Кнопка сбрасывает сессию и перезагружает страницу: подавляющее большинство
 * таких падений приходит из несовместимого состояния в localStorage, когда
 * сервер ушёл вперёд интерфейса. Это ровно тот случай, который пользователь
 * способен починить сам за одно нажатие, не дожидаясь выкладки.
 *
 * Границы применимости: барьер ловит падения РЕНДЕРА. Ошибки запросов ловятся
 * своими catch и показываются в полосе ошибок — они не доходят сюда.
 *
 * Связанные файлы:
 *   - src/main.jsx — монтирует барьер вокруг App;
 *   - src/api.js — хранение токена, которое сбрасывает кнопка.
 */
import React from 'react'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // В консоль — со стеком компонентов: на экране он был бы шумом, а при
    // разборе обращения это первое, что нужно.
    console.error('падение рендера', error, info?.componentStack)
  }

  /** Сбрасывает сохранённую сессию и перезагружает страницу. */
  сбросить = () => {
    try {
      localStorage.clear()
    } finally {
      window.location.reload()
    }
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <div className="center">
        <div className="card-form">
          <h1>Бэклог не открылся</h1>
          <p className="muted">
            Интерфейс не смог построить экран. Чаще всего помогает сброс
            сессии — сервис мог уйти вперёд сохранённого в браузере состояния.
          </p>
          <div className="error">{String(error?.message || error)}</div>
          <div style={{ marginTop: 16 }}>
            <button className="btn" style={{ width: '100%' }} onClick={this.сбросить}>
              Сбросить сессию и перезагрузить
            </button>
          </div>
          <p className="muted" style={{ marginTop: 12 }}>
            Если экран не вернулся — покажите этот текст разработчику.
          </p>
        </div>
      </div>
    )
  }
}
